<template>
	<div v-if="roleForm" class="py-8">
		<RolePermissionsForm :form="roleForm" @on-save="saveRole"/>
	</div>
</template>

<script>
import RolePermissionsForm from "@/Forms/Role/RolePermissionsForm.vue";
import { mapStores } from "pinia";
import { useRolesStore } from "@/stores/roles.js";

export default {
	name: "RolePermissionsView",
	components: {RolePermissionsForm},
	data() {
		return {
			roleForm: undefined,
		}
	},
	computed: {
		...mapStores(useRolesStore)
	},
	methods: {
		async saveRole() {
			try {
				const response = await this.roleForm.submit();
        this.$toast.add({
          severity: 'success',
          summary: this.$t('common.complete'),
          detail: this.$t('pages.admin.users.roles.role.permissions.role_permissions_view.permissions_saved_to_role'),
          life: 3000
        });
				this.$emit('on-save');
				this.$router.replace({ params: {...this.$route.params, role: response.data.id} });
			} catch (error) {
				//
			}
		}
	},
	watch: {
		'$route.params.role': {
			async handler(newValue, oldValue) {
				if(newValue){
					if(this.$route.params.role === 'NEW'){
						this.roleForm = await this.rolesStore.createRole();
					} else {
						this.roleForm = await this.rolesStore.editRole(this.$route.params.role);
					}
				} else {
					this.roleForm = undefined;
				}
			},
			immediate: true,
		}
	},
}
</script>